import api from './api';

const permissionService = {
  // Get all permissions with filtering and pagination
  getAllPermissions: async (category, search = null, page = 1, limit = 100) => {
    try {
      const params = new URLSearchParams({ category, page, limit });
      if (search) params.append('search', search);

      const response = await api.get(`/permissions/?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to fetch permissions';
    }
  },

  // Get permissions as hierarchical tree
  getPermissionTree: async (category = null) => {
    try {
      const params = category ? `?category=${category}` : '';
      const response = await api.get(`/permissions/tree${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to fetch permission tree';
    }
  },

  // Get single permission by ID
  getPermissionById: async (permissionId) => {
    try {
      const response = await api.get(`/permissions/${permissionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to fetch permission';
    }
  },

  // Create a new permission
  createPermission: async (permissionData) => {
    try {
      const response = await api.post('/permissions', permissionData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to create permission';
    }
  },

  // Update an existing permission
  updatePermission: async (permissionId, permissionData) => {
    try {
      const response = await api.patch(`/permissions/${permissionId}`, permissionData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to update permission';
    }
  },

  // Delete a permission
  deletePermission: async (permissionId, force = false) => {
    try {
      const params = force ? '?force=true' : '';
      const response = await api.delete(`/permissions/${permissionId}${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to delete permission';
    }
  },

  // Move permission up or down
  movePermission: async (permissionId, direction) => {
    try {
      const response = await api.patch(`/permissions/${permissionId}/move`, { direction });
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to move permission';
    }
  },

  // Get permission usage (roles using this permission)
  getPermissionUsage: async (permissionId) => {
    try {
      const response = await api.get(`/permissions/${permissionId}/usage`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to get permission usage';
    }
  },

  // Validate permission path
  validatePath: async (path, excludeId = null) => {
    try {
      const payload = { path };
      if (excludeId) payload.exclude_id = excludeId;

      const response = await api.post('/permissions/validate-path', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to validate path';
    }
  }
};

export default permissionService;
